import { Dialog, DialogBody, DialogActions, DialogTitle, DialogDescription } from '@/components/catalyst-ui/dialog'
import { Button } from '@/components/catalyst-ui/button'
import { XMarkIcon } from '@heroicons/react/24/solid'

export default function ProjectAlreadyConnectedDialog({
  open,
  onClose,
  title = 'Project Already Connected',
  message = 'This project is already connected to another domain. Please disconnect the other domain first if you want to connect a different domain to this project.',
  buttonLabel = 'OK',
}) {
  return (
    <Dialog open={open} onClose={onClose} className="!rounded-xl !p-5 !bg-[#FAFAFA]">
      <div className="flex items-start justify-between gap-3">
        <DialogTitle className="!text-lg !font-semibold !text-[#09090B]">
          {title}
        </DialogTitle>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="-mt-2.5 -mr-2.5 rounded-md p-1 cursor-pointer hover:text-[#09090B] transition-colors outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      </div>
      <DialogBody className="!mt-2">
        <DialogDescription className="!text-sm !font-medium !text-[#71717A]">
          {message}
        </DialogDescription>
      </DialogBody>
      <DialogActions className="!mt-4">
        <Button onClick={onClose} color="dark" className="!w-full">
          {buttonLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
